export const alarms: Record<string, string> = {
  'Real-time panic and welfare alerts from guards on site':
    'Alertes de détresse et de bien-être en temps réel des agents sur site',
  'Welfare check': 'Contrôle de bien-être',
  'Security Alerts': 'Alertes de sécurité',
  'Real-time panic alerts from guards on site':
    'Alertes de détresse en temps réel des agents sur site',
  'N/A': 'N/D',
  '{count}s ago': 'il y a {count} s',

  // Status labels
  'Open||alarm': 'Ouverte',
  'Acknowledged||alarm': 'Prise en compte',
  'Resolved||alarm': 'Résolue',
  'Cancelled||alarm': 'Annulée',
  'Open': 'Ouvertes',
  'In Progress': 'En cours',
  'All Clear': 'Tout est en ordre',
  'Total Active': 'Total actives',
  'All||alarms': 'Toutes',

  // Rows and actions
  'Unknown Guard': 'Agent inconnu',
  'Unknown Site': 'Site inconnu',
  'Alarm': 'Alarme',
  'Resolve': 'Résoudre',
  'Needs Response': 'Réponse requise',

  // Toolbar and empty states
  'Search by title, guard or site…': 'Rechercher par titre, agent ou site…',
  'Clear search': 'Effacer la recherche',
  'No alarms match your filters': 'Aucune alarme ne correspond à vos filtres',
  'No active alarms': 'Aucune alarme active',
  'Try adjusting your search or filters': 'Essayez de modifier votre recherche ou vos filtres',
  'All guards are reporting safe': 'Tous les agents sont en sécurité',
  'No alarm history': "Aucun historique d'alarme",
  'Resolved alarms will appear here': 'Les alarmes résolues apparaîtront ici',
  '{count} alarm': '{count} alarme',
  '{count} alarms': '{count} alarmes',
  '{shown} of {total} alarms': '{shown} alarme(s) sur {total}',
  'Clear filters': 'Effacer les filtres',
  'Open incident report': "Ouvrir le rapport d'incident",

  // History table headers
  'Status': 'Statut',
  'Guard': 'Agent',
  'Site': 'Site',
  'Triggered': 'Déclenchée',
  'Duration': 'Durée',
};
